export default "__VITE_ASSET__UyTAfMDx__"